import { Enums, Helpers } from '@bode-canada/core';
import NumberHelper from '@/utils/NumberHelper';

const WHITESPACE = ' ';
const ADDRESS_SEPARATOR = ', ';
const LOT_SIZE_ACCURACY = 2;
const MAIN_IMAGE_INDEX = 0;
const HOUSE_TITLE = 'House';
const propertyTitleByClass = {
  [Enums.BuildingClassEnum.ROW_TOWNHOUSE]: HOUSE_TITLE,
  [Enums.BuildingClassEnum.SEMI_DETACHED]: HOUSE_TITLE,
  [Enums.BuildingClassEnum.DETACHED]: HOUSE_TITLE,
};

export default class ListingMetaHelper {
  static BODE_TITLE_PREFIX = 'For sale on Bode by homeowner';
  static MLS_TITLE_PREFIX = 'Buy on Bode - Represent Yourself';
  static PAGE_INTRODUCTION = 'Bode is a new way to buy or sell your home without a real estate agent.';

  static getPageTitle(listing, prefix = this.MLS_TITLE_PREFIX) {
    return `${prefix} | ${listing.address} ${this.getCommunityAndCityDescription(listing)}`;
  }

  static getPropertyDescription(buildingClass) {
    return Helpers.StringHelper.joinStrings(
      [buildingClass, propertyTitleByClass[buildingClass], 'in'],
      WHITESPACE,
    );
  }

  static getCommunityAndCityDescription(listing) {
    const { community, city } = listing;
    const NONE = 'None';
    const communityText = community === NONE
      ? ''
      : community;

    return `${Helpers.StringHelper.joinStrings([communityText, city], ADDRESS_SEPARATOR)}.`;
  }

  static getListingSizeDescription(listing, price) {
    const {
      beds,
      finishedSqft = 0,
      lotSizeSqft = 0,
      buildingType,
    } = listing;

    return buildingType === Enums.BuildingTypeEnum.VACANT_LAND
      ? `${NumberHelper.sqftToAcres(lotSizeSqft, LOT_SIZE_ACCURACY)} acres, ${price}.`
      : `${beds} Bedroom home with ${finishedSqft} sqft, ${price}.`;
  }

  static getMainImage(listing) {
    return listing.images[MAIN_IMAGE_INDEX]?.highResUrl;
  }

  static buildDescription(descriptionSegments) {
    return Helpers.StringHelper.joinStrings(descriptionSegments, WHITESPACE);
  }
}
